import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileUp, MessageSquare, Wallet, Check, X, Sparkles } from 'lucide-react';
import { api } from '../../context/AuthContext';

const SCHRITTE = {
  unterlagen: { icon: FileUp, to: '/dokumente?upload=1', titel: 'Unterlagen hochladen', text: 'Fotos oder PDFs Ihrer Dokumente sicher an die Kanzlei senden – direkt vom Handy.', knopf: 'Datei hochladen' },
  nachrichten: { icon: MessageSquare, to: '/meine-akten', titel: 'Nachricht schreiben', text: 'Fragen zu Ihrer Akte stellen Sie im Chat – vertraulich und mit Antwort in Ihrem Portal.', knopf: 'Zu den Nachrichten' },
  zahlungen: { icon: Wallet, to: '/portal/zahlungen', titel: 'Zahlungen ansehen', text: 'Rechnungen und Vorschüsse online bezahlen oder einen Ratenplan einsehen.', knopf: 'Zu den Zahlungen' },
};

const Schritt = ({ s, nr, t }) => {
  const c = SCHRITTE[s.id];
  const Icon = c.icon;
  const los = () => { if (s.id === 'zahlungen') api.post('/portal/schnellstart/gesehen', { schritt: 'zahlungen' }).catch(() => {}); };
  return (
    <li className={`relative flex flex-col p-4 rounded-xl border transition-colors ${s.erledigt ? 'bg-emerald-50/60 border-emerald-200' : 'bg-white border-slate-200 hover:border-[#b8893d]/60'}`} data-testid={`schnellstart-schritt-${s.id}`}>
      <div className="flex items-center gap-2.5">
        <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold ${s.erledigt ? 'bg-emerald-600 text-white' : 'bg-[#fbf7f0] text-[#b8893d] ring-1 ring-[#b8893d]/30'}`} data-testid={`schnellstart-status-${s.id}`}>
          {s.erledigt ? <Check className="w-4 h-4" strokeWidth={3} /> : nr}
        </span>
        <Icon className="w-4 h-4 text-[#1B3A5C]" />
        <p className="font-semibold text-sm text-[#1B3A5C]">{t(`schnellstart.${s.id}.titel`, c.titel)}</p>
      </div>
      <p className="text-xs text-slate-600 leading-relaxed mt-2 flex-1">{t(`schnellstart.${s.id}.text`, c.text)}</p>
      {s.erledigt
        ? <p className="mt-3 text-xs font-medium text-emerald-700">{t('schnellstart.erledigt', 'Erledigt')}</p>
        : <Link to={c.to} onClick={los} className="mt-3 self-start inline-flex items-center h-8 px-3 rounded-lg bg-[#1B3A5C] text-white text-xs hover:bg-[#2A5280] transition-colors" data-testid={`schnellstart-los-${s.id}`}>{t(`schnellstart.${s.id}.knopf`, c.knopf)}</Link>}
    </li>
  );
};

export const PortalSchnellstart = () => {
  const { t } = useTranslation();
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/portal/schnellstart').then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.anzeigen) return null;
  const fertig = d.schritte.filter((s) => s.erledigt).length;
  const weg = () => { setD({ ...d, anzeigen: false }); api.post('/portal/schnellstart/ausblenden').catch(() => {}); };
  return (
    <section data-testid="portal-schnellstart">
      <div>
        <div className="rounded-2xl border border-[#b8893d]/30 bg-gradient-to-br from-[#fbf7f0] to-white p-5 sm:p-6 shadow-sm">
          <div className="flex items-start gap-3 mb-4">
            <Sparkles className="w-5 h-5 mt-1 text-[#b8893d] shrink-0" />
            <div className="flex-1 min-w-0">
              <h2 className="font-serif text-xl sm:text-2xl text-[#1B3A5C]">{t('schnellstart.titel', 'Willkommen – so nutzen Sie Ihr Portal')}</h2>
              <p className="text-xs text-slate-500 mt-1" data-testid="schnellstart-fortschritt">{t('schnellstart.fortschritt', { defaultValue: '{{n}} von 3 Schritten erledigt', n: fertig })}</p>
              <div className="mt-2 h-1.5 w-full max-w-xs rounded-full bg-slate-200 overflow-hidden"><div className="h-full bg-[#b8893d] transition-[width] duration-500" style={{ width: `${(fertig / 3) * 100}%` }} /></div>
            </div>
            <button type="button" onClick={weg} aria-label={t('schnellstart.ausblenden', 'Ausblenden')} data-tipp={t('schnellstart.ausblenden', 'Ausblenden')} className="p-1.5 rounded-lg text-slate-400 hover:text-[#1B3A5C] hover:bg-white transition-colors" data-testid="schnellstart-ausblenden"><X className="w-4 h-4" /></button>
          </div>
          <ol className="grid sm:grid-cols-3 gap-3">{d.schritte.map((s, i) => <Schritt key={s.id} s={s} nr={i + 1} t={t} />)}</ol>
        </div>
      </div>
    </section>
  );
};
